// Segmented pill control — the board's `.seg` idiom (region US/EU/CA,
// environment staging/preview, trend window 4w/8w/12w, incident window
// 24h/72h/7d all render as this one control).
//
// Options may carry `available: false` — a locality with no data renders
// disabled, not hidden and never invented (rule 3: the pill set is canonical,
// the availability comes from the data).
export default function PillGroup({ options, value, onChange, label, format = (v) => v }) {
  return (
    <div className="seg" role="group" aria-label={label}>
      {options.map((opt) => {
        const v = typeof opt === 'string' ? opt : opt.value;
        const available = typeof opt === 'string' ? true : opt.available !== false;
        return (
          <button
            key={v}
            type="button"
            className={`seg__pill${v === value ? ' is-on' : ''}`}
            disabled={!available}
            title={available ? undefined : `no data in ${format(v)} yet`}
            aria-pressed={v === value}
            onClick={() => onChange(v)}
          >
            {format(v)}
          </button>
        );
      })}
    </div>
  );
}
